const StatusIconComponent = ({ status }) => {
    let color = '';

    switch (status) {
        case 'completed':
            color = 'var(--message--success)';
            break;
        case 'in_progress':
            color = 'var(--accent)';
            break;
        case 'to_work':
            color = 'var(--accent)';
            break;
        case 'pending':
            color = 'var(--message--warning)';
            break;
        case 'overdue':
            color = 'var(--message--error)';
            break;
        default:
            color = 'var(--label-References-soundtrack-caricato)';
    }

    return(
        <span className="statusIcon" style={{backgroundColor: color}}></span>
    )
}

export default StatusIconComponent;